import script from "./MedAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedAdmin.vue?vue&type=script&setup=true&lang=ts"

import "./MedAdmin.vue?vue&type=style&index=0&id=bf4c6930&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4c6930"]])

export default __exports__